import { ExternalLinkIcon } from '@components/ExternalLinkIcon/ExternalLinkIcon';
import { secondsToHMS } from '@lib/utils/time';
import { Media } from '@typings/Media';
import classNames from 'classnames';
import React from 'react';
import css from '../MediaCard.module.scss';
import { CommentCount } from './CommentCount';

type MediaCardInfoProps = {
  title: {
    value: string;
    origin?: Media['origin'];
    show: boolean;
  };
  duration: {
    value?: number;
    show: boolean;
  };
  /** Zero or absent shows no chip. */
  commentCount?: number;
  isCompact?: boolean;
  /** Before the title: the media's folder, when a search shows it outside the open one. */
  location?: React.ReactNode;
  children?: React.ReactNode;
};

export const MediaCardInfo: React.FC<MediaCardInfoProps> = ({
  title,
  duration,
  commentCount = 0,
  isCompact,
  location,
  children,
}) => {
  const durationValue = duration.show ? duration.value : undefined;
  const showDuration = durationValue !== undefined;
  const showComments = commentCount > 0;
  return (
    <>
      {children}
      {(title.show || showDuration || showComments) && (
        <div className={classNames(css.lower, isCompact && css.compact)}>
          {/* .right must precede .left in DOM for the compact float layout to work.
              CSS order: 1/2 restores visual left-right order in the default flex layout. */}
          {(showDuration || showComments) && (
            <div className={css.right}>
              <CommentCount count={commentCount} className={css.chip} />
              {durationValue !== undefined && (
                <span
                  className={css.chip}
                >{`${secondsToHMS(durationValue, { includeMilliseconds: true, millisecondsPrecision: 2 })}`}</span>
              )}
            </div>
          )}
          {title.show && (
            <div className={css.left}>
              {location}
              {title.origin && <ExternalLinkIcon origin={title.origin} />}
              <span className={css.title}>{title.value}</span>
            </div>
          )}
        </div>
      )}
    </>
  );
};
